/**
 * Color Palette Constants
 *
 * Derived from `libs/ui/theme/src/scss/abstracts/variables/_theme.scss`.
 */

export const THEME = {
  'axonian-gold': '#FEC62E',
  'fusus-dark': '#141217',
  'fusus-surface': '#1F1D23',
  success: '#8DD56A',
  'axon-device-online': '#50ea5f',
  'axon-device-offline': '#FF796A',
};

// RGB Arrays used for Map functions like getFillColor, getLineColor, etc.
export const THEME_RGB_ARR = {
  'axonian-gold': [254, 198, 46],
  'fusus-dark': [20, 18, 23],
  'fusus-surface': [31, 29, 35],
  success: [141, 213, 106],
  'axon-device-online': [80, 234, 95],
  'axon-device-offline': [255, 121, 106],
};
